var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDeleteMui(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15.429,
    viewBox: "0 0 12 15.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-delete",
    transform: "translate(-5 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M5.857,16.714a1.719,1.719,0,0,0,1.714,1.714h6.857a1.719,1.719,0,0,0,1.714-1.714V6.429H5.857ZM17,3.857H14L13.143,3H8.857L8,3.857H5V5.571H17Z",
    transform: "translate(0 0)",
    fill: "#8b9095"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteMui);
export default __webpack_public_path__ + "static/media/ic-delete-mui.56b9ce72.svg";
export { ForwardRef as ReactComponent };